import { useEffect, useState } from 'react';

const axios = require('axios').default;

export const SERIES = {
  holds: { label: 'Holds', color: '#6A4C93' },
  offers: { label: 'Offers', color: '#1982C4' },
  confirms: { label: 'Confirms', color: '#8AC926' },
};

const ARRAY_FILTERS = ['venue_ownership_id', 'team_membership_id', 'buyer_id', 'promoter_id', 'genre_id'];

export function buildBookingParams({ dateRange, comparison, dateMode, activeFilters }) {
  const params = {};
  if (dateRange?.start) params.start_date = dateRange.start;
  if (dateRange?.end) params.end_date = dateRange.end;
  if (comparison?.start) params.prior_start_date = comparison.start;
  if (comparison?.end) params.prior_end_date = comparison.end;
  if (dateMode === 'event_date') params.date_mode = 'event_date';
  ARRAY_FILTERS.forEach((key) => {
    if (activeFilters[key]?.length) params[key] = activeFilters[key];
  });
  if (activeFilters.created_date?.length === 2) {
    [params.created_start_date, params.created_end_date] = activeFilters.created_date;
  }
  return params;
}

export function keepSelectedOptions(filters, activeFilters, labelCache) {
  return filters
    .map((filter) => {
      if (filter.render) return filter;
      const labels = labelCache[filter.key] || {};
      labelCache[filter.key] = labels;
      filter.options.forEach((option) => { labels[option.value] = option.label; });
      const listed = new Set(filter.options.map((option) => option.value));
      const missing = (activeFilters[filter.key] || []).filter((value) => !listed.has(value));
      if (missing.length === 0) return filter;
      return { ...filter, options: [...filter.options, ...missing.map((value) => ({ value, label: labels[value] || value }))] };
    })
    .filter((filter) => filter.render || filter.options.length > 0);
}

export const formatCount = (n) => Number(n || 0).toLocaleString();
export const formatPct = (n) => `${Number(n || 0).toFixed(1)}%`;

export function formatSignedPct(n) {
  if (n === null || n === undefined) return '—';
  const sign = n > 0 ? '+' : n < 0 ? '−' : '';
  return `${sign}${Math.abs(n).toFixed(1)}%`;
}

export const signedColor = (n) => {
  if (!n) return 'var(--sl-text-tertiary)';
  return n > 0 ? 'var(--sl-text-success)' : 'var(--sl-text-error)';
};

const direction = (delta) => {
  if (delta > 0) return 'up';
  if (delta < 0) return 'down';
  return 'flat';
};

export function countChange(current, previous, label) {
  if (!previous) return undefined;
  const pct = ((current - previous) / previous) * 100;
  return { value: `${Math.abs(pct).toFixed(1)}%`, direction: direction(pct), label };
}

export function rateChange(current, previous, label) {
  if (previous === null || previous === undefined) return undefined;
  const delta = current - previous;
  return { value: `${Math.abs(delta).toFixed(1)} pt`, direction: direction(delta), label };
}

export function daysAgo(timestamp) {
  if (!timestamp) return '—';
  const days = Math.floor((Date.now() - new Date(timestamp).getTime()) / 86400000);
  if (days <= 0) return 'Today';
  return `${days}d ago`;
}

export function useBookingFetch(url, params) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const paramsKey = JSON.stringify(params);

  useEffect(() => {
    let active = true;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    axios.get(url, { params })
      .then((res) => { if (active) setState({ data: res.data, loading: false, error: null }); })
      .catch((err) => {
        console.error(err);
        if (active) setState({ data: null, loading: false, error: 'This section could not be loaded.' });
      });
    return () => { active = false; };
  }, [url, paramsKey]);

  return state;
}
